import t from"react";import{MdIcon as i}from"./MdIcon.js";import{mdiLinkedin as e}from"@mdi/js";const o=({id:o="linkedin",title:r="LinkedIn",...m})=>t.createElement(i,{id:o,title:r,path:e,...m});export{o as LinkedinIcon};
